import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";
import { PreviewCard } from "@circleco/compass/components/PreviewCard";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";

import { CommunityHeaderRows } from "./CommunityHeaderRows";
import { DOCK_NAV_ICON_BUTTON_CLASSES } from "./constants";
import type { CommunityRow } from "./useCommunityHeaderRows";

interface CollapsedCommunityTriggerProps {
  canGoBack: boolean;
  children: ReactNode;
  communityName: string;
  onGoBack: () => void;
  rows: CommunityRow[];
}

export const CollapsedCommunityTrigger = ({
  canGoBack,
  children,
  communityName,
  onGoBack,
  rows,
}: CollapsedCommunityTriggerProps) => {
  const trigger = (
    <Tooltip
      content={t("admin_nav_v4.back_to_community")}
      side="bottom"
      delay={500}
    >
      <button
        type="button"
        aria-label={
          canGoBack ? t("admin_nav_v4.back_to_community") : communityName
        }
        onClick={canGoBack ? onGoBack : undefined}
        className={DOCK_NAV_ICON_BUTTON_CLASSES}
      >
        <span className="relative size-6">
          <span
            className={classNames(
              "ease-[cubic-bezier(0.23,1,0.32,1)] absolute inset-0 flex items-center justify-center transition-[opacity,transform] duration-150 motion-reduce:transform-none motion-reduce:transition-opacity",
              {
                "group-hover/dock:-translate-x-0.5 group-hover/dock:opacity-0":
                  canGoBack,
              },
            )}
          >
            {children}
          </span>
          {canGoBack && (
            <span className="ease-[cubic-bezier(0.23,1,0.32,1)] absolute inset-0 flex translate-x-0.5 items-center justify-center opacity-0 transition-[opacity,transform] duration-150 group-hover/dock:translate-x-0 group-hover/dock:opacity-100 motion-reduce:transform-none motion-reduce:transition-opacity">
              <Icon name="arrow-left" size="md" color="primary" />
            </span>
          )}
        </span>
      </button>
    </Tooltip>
  );

  return (
    <PreviewCard
      trigger={trigger}
      side="right"
      align="start"
      className="max-h-[calc(100vh-2rem)] !p-0"
    >
      <div className="max-h-[calc(100vh-2rem)] overflow-y-auto">
        <CommunityHeaderRows rows={rows} />
      </div>
    </PreviewCard>
  );
};
